import { render, staticRenderFns } from "./UpdateWallet.vue?vue&type=template&id=5b70c461"
import script from "./UpdateWallet.vue?vue&type=script&lang=js"
export * from "./UpdateWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports